import * as React from "react";
import type { SVGProps } from "react";
const SvgTrain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.62 14.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.13-.02-.26-.08-.38q-.075-.18-.21-.33c-.28-.28-.73-.37-1.09-.21q-.18.075-.33.21-.135.15-.21.33c-.05.12-.08.25-.08.38 0 .26.11.52.29.71q.15.135.33.21M10 15c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.28-.28.72-.37 1.09-.21.13.05.23.12.33.21.19.19.29.45.29.71s-.1.52-.29.71c-.19.18-.45.29-.71.29"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.88 21.46.243-.46h5.739l.248.47c.18.34.53.53.89.53l-.01.01c.16 0 .32-.04.47-.12.49-.26.68-.86.42-1.35l-1.485-2.813c2.103-.68 3.605-2.46 3.605-4.547V6.77c-.01-1.35-1.02-3.23-2.65-3.92-2.7-1.1-5.99-1.11-8.71 0C6.02 3.53 5 5.41 5 6.77v6.4c0 2.079 1.502 3.858 3.6 4.537L7.11 20.53a.996.996 0 0 0 .42 1.35c.15.08.31.12.47.12l-.01-.01c.36 0 .71-.19.89-.53M13.279 18h-2.573l-.528 1h3.629zM7 11.294v1.866C7 14.73 8.56 16 10.49 16h3.03c1.92 0 3.49-1.27 3.49-2.84v-1.861a4.4 4.4 0 0 1-.82.301h-.02c-1.34.31-2.75.47-4.17.47v-.01a18.7 18.7 0 0 1-4.17-.46 4.5 4.5 0 0 1-.83-.306M7 8.71c.03.17.52.74 1.3.94.872.199 1.78.326 2.7.38V7.026q-1.629.027-3.25.153c-.386.039-.651.208-.75.3zm4.877-3.702a57 57 0 0 0-4.129.16A1.9 1.9 0 0 1 8.4 4.69C9.52 4.24 10.76 4 12 4l.01.01c1.23 0 2.48.24 3.58.69.24.1.46.267.652.469a56 56 0 0 0-4.118-.161 1 1 0 0 0-.247 0M13 7.028v3.002a16 16 0 0 0 2.7-.38c.78-.2 1.26-.77 1.29-.96v-1.2c-.09-.09-.37-.27-.79-.31q-1.591-.12-3.2-.151"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrain;
